<template>
  <v-card v-if="hasComments">
    <v-card-title>Curriculum Comments</v-card-title>
    <v-card-text>
      <v-list>
        <v-list-item-group>
          <v-list-item
            v-for="(topic, index) in showComments"
            :key="index"
          >
            <v-list-item-content>
              <strong>{{ topic.name }}</strong>
              <v-spacer/>
              {{ topic.comment }}
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: function () {
    return {
      showComments: []
    }
  },

  computed: {
    ...mapState(['pupilId', 'Dbasename']),
    hasComments () {
      return Array.isArray(this.showComments) && this.showComments.length > 0
    }
  },
  mounted () {
    this.getCurrComments()
  },
  methods: {
    getCurrComments () {
      this.$http.get('pupilsV2/' + this.Dbasename + '/' + this.pupilId + '/curriculumCommentsV2')
        .then(resp => {
          if (resp.data) {
            this.showComments = resp.data.topics
          }
        })
    }
  }
}
</script>
